import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "./GestionProjet.css";
import ImagesModalCarousel from "../ImagesModalCarousel";
import FormModalProjetClient from "../FormModalProjetClient";
import { loadUserProfile } from "../../redux/actions/authActions";
import PrestatairesDashboard from "../PrestatairesDashboard";
import PrestatairesMatchesDashboardClient from "../PrestatairesMatchesDashboardClient";
import { setActiveProjet, setActiveTabProjet } from "../../redux/actions/dashboardActions";
import LikesDashboard from "../LikesDashboard";
import { Document, Page, pdfjs } from "react-pdf";
import PdfModal from "../PdfModal";
import { cancelProjet, fetchProjetsClients } from "../../redux/actions/projetClientActions";
import PrestaSelectedClientDashboard from "../PrestaSelectedClientDashboard";
import ProjectProgressBar from "../ProjectProgressBar";
import SelectedPresta from "../SelectedPresta";
import { selectMatch } from "../../redux/actions/matchActions";
import { getStatusLabel } from "../../utils/stringUtils";
import PrestataireCardLike from "../PrestataireCardLike";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function GestionProjet() {
    const dispatch = useDispatch();
    const { user, token } = useSelector((state) => state.auth);
    const { activeProjet, activeTabProjet } = useSelector((state) => state.dashboard);
    const projets = useSelector((state) => state.projetClient.listProjets);

    const apiUrl = process.env.REACT_APP_API_URL;

    const [selectedProjet, setSelectedProjet] = useState(null);
    //const [activeTabProjet, setActiveTabProjet] = useState("projet");
    const [activeNameTabProjet, setActiveNameTabProjet] = useState("Projet");
    const [modalIndex, setModalIndex] = useState(null);
    const [openFormProjet, setOpenFormProjet] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const openPdf = (file, categorie) => {
        setPdfUrl(`${apiUrl}/api/files/?categorie=${categorie}&file=${file}`);
    };
    const [menuOpen, setMenuOpen] = useState(false); // ✅ menu burger
    useEffect(() => {
        if (token) dispatch(fetchProjetsClients(token));
    }, [])
    if (!user || !user.profilClient) return <p>Chargement...</p>;



    const refreshProjets = () => {
        if (token) dispatch(fetchProjetsClients(token));
    };

    const tabStyle = (tab) => ({
        padding: "10px 18px",
        cursor: "pointer",
        borderBottom:
            activeTabProjet === tab ? "3px solid #007bff" : "3px solid transparent",
        fontWeight: activeTabProjet === tab ? "bold" : "normal",
        transition: ".25s",
    });

    const handleTabClick = (tab) => {
        dispatch(selectMatch(null));
        dispatch(setActiveTabProjet(tab));
        setMenuOpen(false);
    };



    const getActiveTabName = () => {

        switch (activeTabProjet) {
            case "projet":
                return "Projet";
            case "trouver":
                return "Trouver un prestataire";
            case "likesSent":
                return "Likes envoyés";
            case "likesReceived":
                return "Likes reçus";
            case "matchs":
                return "Matchs actifs";
        }
    }

    return (
        <div className="gestion-projet">

            <style>{`
                /* ---------------------------------------------------------
                    🌐 Responsive styles
                ---------------------------------------------------------- */
                .tabs-container {
                    display: flex;
                    gap: 20px;
                    margin-top: 15px;
                    margin-bottom: 25px;
                }

                /* -------- Menu burger visible mobile -------- */
                .burger-btn {
                    display: none;
                    background: #007bff;
                    color: white;
                    border: none;
                    padding: 10px 15px;
                    border-radius: 6px;
                    font-size: 16px;
                    cursor: pointer;
                }

                @media (max-width: 768px) {
                    .tabs-container {
                        display: none;
                    }
                    .burger-btn {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width:fit-content;
                        margin:auto;

                    }
                    .burger-menu {
                        background: white;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        padding: 15px;
                        margin-bottom: 20px;
                        box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                    }
                    .burger-item {
                        padding: 12px 10px;
                        border-bottom: 1px solid #eee;
                        cursor: pointer;
                        font-size: 16px;
                    }
                    .burger-item:last-child {
                        border-bottom: none;
                    }
                }
            `}</style>

            <h2 className="gestion-projet-title">
                {!activeProjet
                    ? "Gestion de mes projets"
                    : "Gestion du projet " + activeProjet.titreProjetClient}
            </h2>
            {
                activeProjet && (
                    <button className="back-btn-projets" onClick={() => dispatch(setActiveProjet(null))}>
                        ← Retour
                    </button>
                )
            }


            {!activeProjet && (
                <button className="btn-primary" onClick={() => setOpenFormProjet(true)}>
                    Créer un nouveau projet
                </button>
            )}

            {/* ---------------------------------------------------------
                🎯 PROJET SELECTIONNÉ
            ---------------------------------------------------------- */}
            {activeProjet && (
                <div className="projet-detail">

                    <div className="mobile-bubbles">
                        <button
                            className={`bubble-tab ${activeTabProjet === "projet" ? "active" : ""}`}
                            onClick={() => handleTabClick("projet")}
                        >
                            Projet
                        </button>
                        {
                            activeProjet.statusProjetClient === "posted" && (
                                <>
                                    <button
                                        className={`bubble-tab ${activeTabProjet === "trouver" ? "active" : ""}`}
                                        onClick={() => handleTabClick("trouver")}
                                    >
                                        Trouver Prestataire
                                    </button>

                                    <button
                                        className={`bubble-tab ${activeTabProjet === "matchs" ? "active" : ""}`}
                                        onClick={() => handleTabClick("matchs")}
                                    >
                                        Matchs
                                    </button>
                                </>

                            )
                        }
                        {
                            activeProjet.statusProjetClient === "prestataire_selected" && (
                                <button
                                    className={`bubble-tab ${activeTabProjet === "prestataire_selected" ? "active" : ""}`}
                                    onClick={() => handleTabClick("prestataire_selected")}
                                >
                                    Prestataire choisi
                                </button>
                            )
                        }
                        {
                            activeProjet.statusProjetClient === "realised" && (
                                <button
                                    className={`bubble-tab ${activeTabProjet === "realised" ? "active" : ""}`}
                                    onClick={() => handleTabClick("realised")}
                                >
                                    Prestataire
                                </button>
                            )
                        }



                    </div>



                    {/* ======== TABS DESKTOP ======== */}
                    <div className="tabs-container">
                        <div style={tabStyle("projet")} onClick={() => dispatch(setActiveTabProjet("projet"))}>
                            Projet
                        </div>
                        {
                            activeProjet.statusProjetClient === "posted" && (
                                <>
                                    <div style={tabStyle("trouver")} onClick={() => dispatch(setActiveTabProjet("trouver"))}>
                                        Trouver un prestataire
                                    </div>

                                    <div style={tabStyle("matchs")} onClick={() => { dispatch(setActiveTabProjet("matchs")); dispatch(selectMatch(null)) }}>
                                        Matchs
                                    </div>

                                </>
                            )
                        }
                        {
                            activeProjet.statusProjetClient === "prestataire_selected" && (
                                <div style={tabStyle("prestataire_selected")} onClick={() => { dispatch(setActiveTabProjet("prestataire_selected")); dispatch(selectMatch(null)) }}>
                                    Prestataire choisi
                                </div>
                            )
                        }
                        {
                            activeProjet.statusProjetClient === "realised" && (
                                <div style={tabStyle("realised")} onClick={() => { dispatch(setActiveTabProjet("realised")); dispatch(selectMatch(null)) }}>
                                    Prestataire
                                </div>
                            )
                        }


                    </div>

                    {/* ---------------------------------------------------------
                        CONTENU DES TABS
                    ---------------------------------------------------------- */}
                    {activeTabProjet === "projet" && (
                        <>
                            <h3>{activeProjet.titreProjetClient}</h3>
                            {
                                activeProjet.statusProjetClient === "posted" && (
                                    <button className="btn-primary" onClick={() => dispatch(cancelProjet(token, activeProjet.idProjetClient))}>ANNULER</button>

                                )
                            }
                            <p>{activeProjet.descriptionProjetClient}</p>

                            <div className="projet-infos">
                                <p>
                                    <strong>Secteur :</strong> {activeProjet.secteurProjetClient}
                                </p>
                                <p>
                                    <strong>Budget :</strong> {activeProjet.budgetProjetClient === "50000-1000000" ? "Plus de 50000" : activeProjet.budgetProjetClient} €
                                </p>
                                <p>
                                    <strong>Ville :</strong> {activeProjet.villeProjetClient}
                                </p>
                                <p>
                                    <strong>Status :</strong> {getStatusLabel(activeProjet.statusProjetClient)}
                                </p>

                            </div>

                            {activeProjet.besoinsProjetClient?.length > 0 && (
                                <div className="projet-besoins">
                                    {activeProjet.besoinsProjetClient.map((besoin) => (
                                        <span
                                            key={besoin.idBesoinProjetClient}
                                            className="besoin-badge"
                                        >
                                            <img
                                                src={`${apiUrl}/api/files/?categorie=metiers&file=${besoin.metier.iconMetier}`}
                                                alt={besoin.metier.labelMetier}
                                                className="besoin-icon"
                                            />
                                            {besoin.metier.labelMetier} (x{besoin.nbPersonnes})
                                        </span>
                                    ))}
                                </div>
                            )}

                            <div className="section">
                                <h4>Photos</h4>
                                {activeProjet.photosProjetClient?.length > 0 ? (
                                    <div className="photo-gallery">
                                        {activeProjet.photosProjetClient?.map((img, index) => (
                                            <img
                                                key={img.idFileProjetClient}
                                                src={`${apiUrl}/api/files/?categorie=projets&file=${img.fileNameFileProjetClient}`}
                                                className="photo-thumb"
                                                onClick={() => setModalIndex(index)}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <p>Aucune photo pour ce projet.</p>
                                )}
                            </div>

                            <div className="section">
                                <h4>📎 Documents</h4>

                                {activeProjet.docsProjetClient?.length > 0 ? (
                                    activeProjet.docsProjetClient.map((doc) => (
                                        <div
                                            key={doc.idFileProjetClient}
                                            className="pdf-thumbnail"
                                            onClick={() => openPdf(doc.fileNameFileProjetClient, "projets")}
                                        >
                                            <Document
                                                file={`${apiUrl}/api/files/?categorie=projets&file=${doc.fileNameFileProjetClient}`}
                                            >
                                                <Page pageNumber={1} width={120} />
                                            </Document>
                                        </div>
                                    ))
                                ) : (
                                    <p>Aucun document pour ce projet</p>
                                )}
                            </div>

                        </>
                    )}

                    {activeTabProjet === "trouver" && (
                        <PrestatairesDashboard projet={activeProjet} />
                    )}

                    {activeTabProjet === "matchs" && (
                        <PrestatairesMatchesDashboardClient
                            projet={activeProjet}
                        />
                    )}

                    {activeTabProjet === "prestataire_selected" && (
                        <SelectedPresta
                            projet={activeProjet}
                        />
                    )}

                    {activeTabProjet === "realised" && (
                        <PrestataireCardLike
                            prestataire={activeProjet.selectedPresta}
                            projet={activeProjet}
                            apiUrl={process.env.REACT_APP_API_URL}
                            onLike={null}
                            onPass={null}
                            isReceivedLike={false}
                            isAlreadyMatched={true}
                        />
                    )}

                    {modalIndex !== null && (
                        <ImagesModalCarousel
                            images={activeProjet.photosProjetClient}
                            startIndex={modalIndex}
                            onClose={() => setModalIndex(null)}
                        />
                    )}
                </div>
            )}
            {!activeProjet && (
                <div className="projets-grid">
                    {projets.map((projet) => (
                        projet.statusProjetClient !== "canceled" && (
                            <div
                                key={projet.idProjetClient}
                                className="projet-card clickable"
                                onClick={() => {
                                    dispatch(setActiveProjet(projet));
                                    dispatch(setActiveTabProjet("projet"));
                                }}
                            >
                                <div className="projet-header">
                                    <h3 className="projet-title">{projet.titreProjetClient}</h3>
                                    <span
                                        className={`status-badge status-${projet.statusProjetClient}`}
                                    >
                                        {getStatusLabel(projet.statusProjetClient)}
                                    </span>
                                </div>
                                <p>{projet.descriptionProjetClient}</p>
                                {
                                    projet.selectedPresta !== null && projet.statusProjetClient === "realised" && (
                                        <>
                                            <h4>Réalisé par {projet.selectedPresta?.raisonSocialePrestataire}</h4>
                                            <p><span>Avis déposé :</span>{projet.avis.commentaires}</p></>
                                    )
                                }

                            </div>
                        )

                    ))}
                </div>
            )}

            {openFormProjet && (
                <FormModalProjetClient
                    onClose={() => {
                        setOpenFormProjet(false);
                        refreshProjets();
                    }}
                />
            )}
            {pdfUrl && <PdfModal fileUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}

        </div>
    );
}
